<template>
  <div class="product-content">
    <el-dialog title="生成证书" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="common-form">生成操作</div>
      <el-form :model="detail">
        <el-form-item label="选择证书背景" :label-width="formLabelWidth">
          <div>
            <el-radio-group v-model="path" v-for="item in imgs" :value="item" :key="item" style="margin: 20px;">
              <el-radio :label="item"><img :src="item" style="width: 100px;height: 100px;"></el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer"  class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="makeUserCertImg">确 定</el-button>
      </div>
      
    </el-dialog>
  </div>
</template>

<script>
import PlusApi from '@/api/plus.js';
export default {
  data() {
    return {
      detail:{},
      path:'',
      /*左边长度*/
      formLabelWidth: '200px',
      imgs:{},
      /*是否显示*/
      dialogVisible: false
    };
  },
  props: ['open_make', 'form'],
  created() {
    this.dialogVisible = this.open_make;
    this.detail=this.form
    this.getCertImgs();
  },
  methods: {
    /*修改用户*/
    makeUserCertImg() {
      let self = this;
      let params = {};
      params.back = self.path;
      params.user_id = self.detail.user.user_id
      
      PlusApi.makeCertImg(params, true)
        .then(data => {
          self.$message({
            message: '恭喜你，修改成功',
            type: 'success'
          });
          self.dialogFormVisible(true);
        })
        .catch(error => {
         
        });
    },

    /*获取证件背景图信息*/
    getCertImgs() {
      let self = this;
      PlusApi.getCertConfig({}, true)
        .then(data => {
          self.imgs = data.data.vars.image
          
          // self.certification=data.data.detail
          
        })
        .catch(error => {});
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    }
  }
};
</script>

<style>
.el-dialog__body{
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/user/setting/part/Make.vue